import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { adrEntityContentExtension } from '@backstage-community/plugin-adr/alpha';

/**
 * The plugin's own `entity-content:adr`, with only the loader swapped for a
 * @backstage/ui page (./AdrContent). Path `/adrs`, the `isAdrAvailable` filter
 * and the route ref stay the plugin's, so there is still exactly one ADRs tab
 * and its links keep working.
 */
const adrEntityContent = adrEntityContentExtension.override({
  params: {
    loader: () => import('./AdrContent').then(m => <m.AdrContent />),
  },
});

export const adrModule = createFrontendModule({
  pluginId: 'adr',
  extensions: [adrEntityContent],
});
